import { render, staticRenderFns } from "./upgradePackage.vue?vue&type=template&id=1b9bbf3a&scoped=true&"
import script from "./upgradePackage.vue?vue&type=script&lang=js&"
export * from "./upgradePackage.vue?vue&type=script&lang=js&"
import style0 from "./upgradePackage.vue?vue&type=style&index=0&id=1b9bbf3a&prod&lang=css&"
import style1 from "./upgradePackage.vue?vue&type=style&index=1&id=1b9bbf3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9bbf3a",
  null
  
)

export default component.exports